<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body, #app {
 /* height: calc(100% - 70px); */
 /* min-width: 1200px; */

 margin: 0;
 padding: 0;
 height: 100vh;
 /* margin-bottom: 70px; */
 /* padding-bottom: 70px; */
 /* box-sizing: border-box; */
}
#app {
  /* position:relative;   */
  /* padding-bottom: 100px;   */
  box-sizing: border-box;
  /* color: #f4f4f4; */
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul,li {
  list-style: none;
  margin: 0;
 padding: 0;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue